import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { stripedIndicatorBackground } from "./stripedFill";

const InlineHeaderCell = styled.div`
    display: inline-block;
`;

/**
 * Header content for a comparison column: a small dot (striped for the previous
 * period, solid for the current period) followed by the column label.
 *
 * Wrapped in `display: inline-block` so antd's `text-align` on the `<th>` cell
 * anchors the whole dot+label block to the column's natural edge (used in tandem
 * with `align: "right"` for value columns and default for everything else).
 */
export const renderHeaderWithIndicator = (label: string, isPreviousPeriod: boolean) => (
    <InlineHeaderCell>
        <Flex
            alignItems="center"
            gap="6px"
        >
            <Box
                width="8px"
                height="8px"
                borderRadius="50%"
                flexShrink={0}
                background={isPreviousPeriod ? stripedIndicatorBackground : colorsPalettes.carbon[200]}
            />
            <Text fontVariant="captionTitle">{label}</Text>
        </Flex>
    </InlineHeaderCell>
);
